<template>
  <div class="divider">
    <div class="divider-text">
      <slot/>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.divider {
  position: relative;
  color: #3394e1;
  display: block;
  width: 100%;
  height: 1px;
  margin: 24px 0;
  margin-bottom: 30px;
  background: #3394e1;
}
.divider-text {
  color: #3394e1;
  transform: translateY(-50%);
  left: 38px;
  position: absolute;
  background-color: #fff;
  padding: 0 20px;
  font-weight: 500;
  font-size: 14px;
}
.left{
    left: 38px;
}
.right{
    right: 38px;
}
.center{
    left: 50%;
    transform: translateX(-50%);
}
</style>
<script>
export default {}
</script>
